// ** Third Party Components
import { useTranslation } from "react-i18next"
import ReactCountryFlag from "react-country-flag"
// ** Reactstrap Imports
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap"
import { genericContext } from "../../../../context/generic"

const IntlDropdown = () => {
  const { i18n, t } = useTranslation()
  const { setLanguage } = genericContext()
  // ** Hooks
  // ** Vars
  const langObj = {
    en: t("English"),
    es: t("Spanish")
  }

  // ** Function to switch Language
  const handleLangUpdate = (e, lang) => {
    e.preventDefault()
    i18n.changeLanguage(lang)
    setLanguage(lang)
  }

  return (
    <UncontrolledDropdown
      href="/"
      tag="div"
      className="dropdown-language"
    >
      {/*
        El diseño muestra bandera + código de dos letras dentro de una caja con borde,
        no el nombre completo del idioma sobre fondo transparente.
      */}
      <DropdownToggle
        href="/"
        tag="a"
        className="bp-header-btn"
        onClick={(e) => e.preventDefault()}
        title={langObj[i18n.language]}
      >
        <ReactCountryFlag
          svg
          className="country-flag flag-icon"
          countryCode={i18n.language === "en" ? "us" : i18n.language}
        />
        <span className="selected-language">
          {(i18n.language ?? "es").slice(0, 2).toUpperCase()}
        </span>
      </DropdownToggle>
      <DropdownMenu className="mt-0" end>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "es")}
        >
          <ReactCountryFlag className="country-flag" countryCode="es" svg />
          <span className="ms-1">{t("Spanish")}</span>
        </DropdownItem>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "en")}
        >
          <ReactCountryFlag className="country-flag" countryCode="us" svg />
          <span className="ms-1">{t("English")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default IntlDropdown
